// src/reducers/storeReducer.js
import {
  FETCH_STORE_REQUEST,
  FETCH_STORE_SUCCESS,
  FETCH_STORE_FAILURE,
  CREATE_STORE_ITEM_REQUEST,
  CREATE_STORE_ITEM_SUCCESS,
  CREATE_STORE_ITEM_FAILURE,
  UPDATE_STORE_ITEM_REQUEST,
  UPDATE_STORE_ITEM_SUCCESS,
  UPDATE_STORE_ITEM_FAILURE,
  DELETE_STORE_ITEM_REQUEST,
  DELETE_STORE_ITEM_SUCCESS,
  DELETE_STORE_ITEM_FAILURE,
} from "../actions/types";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_REQUEST:
    case CREATE_STORE_ITEM_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_STORE_ITEM_REQUEST:
    case DELETE_STORE_ITEM_REQUEST:
      return { ...state, error: null };

    case FETCH_STORE_SUCCESS:
      return { ...state, loading: false, items: action.payload };

    case CREATE_STORE_ITEM_SUCCESS:
      return { ...state, loading: false, items: [action.payload, ...state.items] };

    case UPDATE_STORE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map((item) =>
          item.entityId === action.payload.entityId ? action.payload : item
        ),
      };

    case DELETE_STORE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter((item) => item.entityId !== action.payload),
      };

    case FETCH_STORE_FAILURE:
    case CREATE_STORE_ITEM_FAILURE:
    case UPDATE_STORE_ITEM_FAILURE:
    case DELETE_STORE_ITEM_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default storeReducer;
